import React, {FC, PropsWithChildren, useState} from 'react';

// import library.
import { useFieldArray, useForm, useFormContext, Controller, FormProvider, FieldArrayWithId, ArrayPath } from 'react-hook-form';

import NumberFormat from 'react-number-format';
// mui ...
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';

import {IFeatureParameter} from '../component/utils/interface';

import TextFieldRight from './TextFieldRight';

// import { fi } from 'date-fns/locale';
// import { FlowFlags } from 'typescript';


// export interface ArrayField {
//     name: string, 
//     text: string ,
//     enumeration: string, 
//     value: any
// } 

//type DataType = 'string' | 'numeric' | 'bool' | 'date';

// export interface HeadCell<T> {
//   //disablePadding: boolean;
  
  

//   itemsValue: {code: string, name: string}[],
//   //numeric: boolean;
//   type: DataType  
// }

export interface ArrayActionParamBoxProps  {
    //controlSize: number,
    // valueMember: keyof T,
    // labelMember: keyof T,

    // typeMember: keyof T,

    //fields: FieldArrayWithId<O, ArrayPath<O> >[],

    fields: IFeatureParameter[],

    fieldsName: string,

    fieldsPerRow?: 1 | 2 | null
} 



//export function ArrayFieldBox  (props : ArrayFieldBoxProps)  {
export default function ArrayActionParamBox  (props : ArrayActionParamBoxProps)  {
    
  const {fields, fieldsName, fieldsPerRow  } = props;

  const _fieldsPerRow = (fieldsPerRow || 1) as number;

  const w = _fieldsPerRow === 2? '50' : '100' as string;

  // console.log('w');
  // console.log(w);

  const {  control  } = useFormContext();  

  
    //const count = fields.length;

    function displayCell(fieldParam: IFeatureParameter, idx: number ) : React.ReactNode {
      
      if( (fieldParam.type) === 'bool')
        return (<Controller 
                name={`${fieldsName}.${idx}.value`} 
                control={control}
                render={({ field }) => <Checkbox {...field} />}
             />);

      if(fieldParam.type === 'numeric')
        return (<Controller
          render={({ field }) => {
            return (
              <NumberFormat sx={{width:`calc(${w}% - 8px)`,  style: { textAlign: 'right' }}}
                label={fieldParam.label}
                //decimalScale={2}
                allowEmptyFormatting={false}
                control={control}                          
                //fixedDecimalScale={true}              
                         
                thousandSeparator={true}
                {...field}
                customInput={TextFieldRight}
                //customInput={(props) => <TextField {...props} sx={{width:'calc(20% - 8px)'}} id="roleName" inputProps={{style: { textAlign: 'right' }}} />}
              />
            );
          }}
          name={`${fieldsName}.${idx}.eltValue`} 
          control={control}
        />);
        
        if(fieldParam.type === 'string' && fieldParam.options && fieldParam.enumerationCode && fieldParam.enumerationCode !== 'TEXT')
          return (<Controller
            render={ ({field: {onChange, value}}) => (
              <TextField select onChange={onChange} value={value} sx={{width:`calc(${w}% - 8px)`}}
                id={fieldParam.name} label={fieldParam.label} >
              {fieldParam.options && fieldParam.options.map( 
                (opt,ix) => <MenuItem key={opt.value} value={opt.value}>{opt.value}</MenuItem> )
              }
              </TextField>
            )}
            name={`${fieldsName}.${idx}.value`} 
            control={control}
          />);

          return (<Controller             
            render={({ field }) => <TextField sx={{width:`calc(${w}% - 8px)`}} {...field} label={fieldParam.label}   />}
            name={`${fieldsName}.${idx}.value`} 
            control={control}
        />);
    }

    return ( 
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
          <Box sx={{ mt: 1, width: '100%' }} >   
            { fields.map( (x,idx) => (
              (idx%_fieldsPerRow===0)? <Box key={idx} sx={{ mt: 1, width: '100%' }} >
                {displayCell(x,idx)}
                {(_fieldsPerRow === 2 && idx+1<fields.length)?displayCell(fields[idx+1],idx+1):null}                                
              </Box> : null)
             )}
          </Box>
        </Box>);    
}

